var exports = {
  "aN": "GuildSettingsModal.module__sidebarHeader___LVpJWW",
  "J5": "GuildSettingsModal.module__guildName___LVpJWW",
  "YO": "GuildSettingsModal.module__channelNameWithIcon___LVpJWW",
  "er": "GuildSettingsModal.module__channelNameIcon___LVpJWW",
  "Kw": "GuildSettingsModal.module__channelNameText___LVpJWW",
  "i7": "GuildSettingsModal.module__sidebarButtonWrapper___LVpJWW",
  "cy": "GuildSettingsModal.module__sidebarButtonIcon___LVpJWW",
  "Db": "GuildSettingsModal.module__externalTabLabel___LVpJWW",
  "wG": "GuildSettingsModal.module__externalTabLabelText___LVpJWW",
  "Gs": "GuildSettingsModal.module__externalTabIcon___LVpJWW",
};

module.exports = exports;
